import React, { useState } from 'react';
import Loading from 'components/Loading';
import { useTranslation } from 'react-i18next';
import { ChartSettingsT } from 'business/definitions';
import { IconButton, styled } from '@mui/material';
import { Download } from '@mui/icons-material';
import TableAgChart from '../../Chart/graphs/TableChart/TableAgChart';

const StyMetricTabWrapper = styled('div', {
    name: 'StyMetricTabWrapper',
})(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    padding: '1em',
    gap: theme.spacing(1),
}));

type Props = {
    isLoading: boolean;
    columns: ResponseColumnT[];
    data: ResponseDataT[];
    exportToFile: () => void;
};

const MetricTab = ({
    isLoading,
    columns,
    data,
    exportToFile,
}: Props): React.ReactElement => {
    const { t } = useTranslation();
    const [tableSettings, setTableSettings] = useState<ChartSettingsT>({
        rowHeight: 'sm',
        showFilters: true,
        pageSize: 15,
    });

    return isLoading || !data || !columns ? (
        <div>
            <Loading />
            <div>{t('rawDataModal.loading')}</div>
        </div>
    ) : (
        <StyMetricTabWrapper>
            <IconButton
                onClick={exportToFile}
                sx={{ alignSelf: 'flex-end' }}
                color="primary"
            >
                <Download />
            </IconButton>
            <TableAgChart
                className="raw-data"
                orderedColumns={columns}
                data={data}
                settings={tableSettings}
                hideSideBar
                autoSizeColumns
                autoSizeHeight
                applyChartSettings={setTableSettings}
            />
        </StyMetricTabWrapper>
    );
};

const MemoMetricTab = React.memo<Props>(MetricTab);
export default MemoMetricTab;
